export default {
  path: '/2019AdvancerVolunteerSelection',
  name: '2019AdvancerVolunteerSelection',
  component: () => import('./Home.vue'),
  redirect: '/2019AdvancerVolunteerSelection/HomeIndex',
  meta: {
    title: '2019年重庆市志愿服务先进典型宣传推选',
  },
  children: [
    {
      path: 'HomeIndex',
      component: () => import('./HomeIndex.vue'),
      name: '2019AdvancerVolunteerSelection/HomeIndex',
      meta: {
        title: '2019年重庆市志愿服务先进典型宣传推选',
      },
    },
    {
      path: 'Activities',
      component: () => import('./Activities.vue'),
      name: '2019AdvancerVolunteerSelection/Activities',
      meta: {
        title: '2019年重庆市志愿服务先进典型宣传推选',
      },
    },
    {
      path: 'RelativeNews',
      component: () => import('./RelativeNews.vue'),
      name: '2019AdvancerVolunteerSelection/RelativeNews',
      meta: {
        title: '2019年重庆市志愿服务先进典型宣传推选',
      },
    },
    {
      path: 'SelectRules',
      component: () => import('./SelectRules.vue'),
      name: '2019AdvancerVolunteerSelection/SelectRules',
      meta: {
        title: '2019年重庆市志愿服务先进典型宣传推选',
      },
    },
    {
      path: 'HomeIndexSelectRules',
      component: () => import('./HomeIndexSelectRules.vue'),
      name: '2019AdvancerVolunteerSelection/HomeIndexSelectRules',
      meta: {
        title: '2019年重庆市志愿服务先进典型宣传推选',
      },
    },
    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: '2019AdvancerVolunteerSelection/DetailPage',
      meta: {
        title: '2019年重庆市志愿服务先进典型宣传推选',
      },
    },
  ],
};
